import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Banner } from 'src/app/model/shared/banner';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-known-issues-page',
  templateUrl: './known-issues-page.component.html',
  styleUrls: ['./known-issues-page.component.scss']
})
export class KnownIssuesPageComponent implements OnInit {
  pageTitle = '';
  href = '';
  banner: Banner = {} as Banner;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.href = this.router.url.includes('#') ? this.router.url.split('-').pop() || '' : '';
    this.activatedRoute.params.subscribe((params) => (this.pageTitle = params['pageTitle']));
    this.sharedDataService.sharedData.subscribe((banner) => {
      this.banner = banner;
    });
  }
}
